<template>
  <b-row v-if="!dataLoad">
    <b-col
      cols="12"
      md="4"
    >
      <SelectSearchOnly
        :show-select-search="true"
        @handleSearchOnly="handleSearch"
      />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <SelectTaksStatus
        :show-select-activities="true"
        @handleTaksStatus="handleTaksStatus"
      />
    </b-col>
    <b-col
      cols="12"
      md="2"
    >
      <SelectPriority
        :show-select-status="true"
        @handlePriority="handlePriority"
      />
    </b-col>
    <b-col
      md="2"
      cols="12"
      class="d-flex align-items-center justify-content-between"
    >
      <feather-icon
        v-b-popover.hover.top="'Clear All Filters'"
        icon="RefreshCwIcon"
        size="25"
        class="cursor-pointer"
        color="#297dd6"
        @click="clearAllData"
      />
      <SearchBtnAction
        :view-search-btn="true"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />
    </b-col>
  </b-row>
</template>

<script>
import SelectTaksStatus from './fixed-filter/SelectTaksStatus.vue'
import SelectPriority from './fixed-filter/SelectPriority.vue'
import SearchBtnAction from '../actions/SearchBtnAction.vue'
import SelectSearchOnly from './fixed-filter/SelectSearchOnly.vue'

export default {
  components: {
    SelectPriority,
    SelectTaksStatus,
    SearchBtnAction,
    SelectSearchOnly,
  },
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
  methods: {
    handlePriority(status) {
      this.$emit('handlePriority', status)
    },
    handleTaksStatus(name) {
      this.$emit('handleTaksStatus', name)
    },
    handleSearch(name) {
      this.$emit('handleSearchOnly', name)
    },
    clearAllData() {
      this.$router.replace({ query: {} })
      this.getAllData(1)
    },
  },
}
</script>
